import withIcon from './NewIcon';
// @ts-ignore
import IconQuote from './icon/m/quote.s.svg';

export default withIcon(IconQuote);
